/*eslint-disable no-self-compare */
export const isFunction = (data: any) => {
  return typeof data === 'function';
};
